import { TaskTab } from '@/common/components/business/ExpandStore/ts-config';

/**
 * @Description
 */
export default {
  meta: {
    title: '拓店任务', // 拓店任务-森马
  },
};


export const initialTab = [
  { label: '我发起的', key: TaskTab.Created },
  { label: '我的任务', key: TaskTab.AssignMe },
  { label: '待指派', key: TaskTab.WaitAssign },
];
